const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-extension-google/shared/GoogleMaps/LayersMenu");